import { useBackgroundMedia } from './useBackgroundMedia';

const VIDEO_SRC = '/videos/heros-bg-720p.mp4';
const POSTER_SRC = '/videos/heros-bg-poster.webp';

/** Native forward/reverse loop, with a real still image when motion is disabled. */
export function useHeroVideo() {
    return useBackgroundMedia(VIDEO_SRC, POSTER_SRC);
}
